<template>
    <o-form-group
        :id="this_id"
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <o-form-select
            :id="this_id"
            :options="options"
            :blank-option-text="nullName"
            text-field="name"
            dont-sort
            :value="value"
            value-field="value"
            @change="updateSelect"
        >
        </o-form-select>
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin.js";
import SelectInputMixin from "./private/SelectInputMixin.js";
import OFormGroup from "../OFormGroup.vue";

export default {
    name: "OBooleanSelect",
    components: { OFormGroup },
    mixins: [FormComponentMixin, SelectInputMixin],
    model: {
        event: "change",
        prop: "value",
    },
    props: {
        value: { type: Boolean, default: null },
        trueName: { type: String, default: "Yes" },
        falseName: { type: String, default: "No" },
        nullName: { type: String, default: "" },
    },
    computed: {
        options() {
            return [
                { value: null, name: this.nullName },
                { value: true, name: this.trueName },
                { value: false, name: this.falseName },
            ];
        },
    },
    methods: {
        updateSelect(value) {
            this.$emit("change", value);
        },
    },
};
</script>

<style scoped></style>
